module.exports = __webpack_public_path__ + "img/ic_network_building.43a44409.png";